import styles from "../../styles/PLMApp.module.css";
// TOAST SYSTEM
// src/components/plm/Toast.jsx

// ─────────────────────────────────────────────
export default function Toast({ message }) {
  if (!message) return null;
  return (
    <div className={styles.toast}>
      <div className={styles.toastDot} />
      {message}
    </div>
  );
}
